import * as yup from 'yup';

import { convertYupErrorToMessagesObject } from '@shared/utils/validation.utils';
import {
    fullNameSchema, phoneSchema, passwordSchema, confirmPasswordSchema,
} from '../auth.validation';

export const validateChallengeNewPasswordRequired = async (data) => {
    const schema = await yup.object().shape({
        attributes: yup.object().shape({
            name: fullNameSchema,
            phone: phoneSchema,
        }),
        password: await passwordSchema(),
        confirmPassword: confirmPasswordSchema,
    });

    return schema.validate(data, {
        convert: true,
        abortEarly: false,
    }).catch(error => Promise.reject(convertYupErrorToMessagesObject(error)));
};
